import { Injectable, Injector } from '@angular/core';
import {
  HttpRequest,
  HttpHandler,
  HttpEvent,
  HttpInterceptor,
} from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { Router, NavigationExtras } from '@angular/router';
//import { ToastrService } from 'ngx-toastr';
import { catchError } from 'rxjs/operators';
import { MatSnackBar } from '@angular/material/snack-bar';
import { TranslateService } from '@ngx-translate/core';
import { RedirectErrors } from '../models/redirect-errors.enum';

@Injectable()
export class ErrorInterceptor implements HttpInterceptor {
  constructor(
    private router: Router,
    private _snackBar: MatSnackBar,
    private _injector: Injector // private _translate: TranslateService
  ) {}

  intercept(
    request: HttpRequest<unknown>,
    next: HttpHandler
  ): Observable<HttpEvent<unknown>> {
    return next.handle(request).pipe(
      catchError((error) => {
        console.error(error);
        if (error) {
          switch (error.status) {
            case 400:
              if (error.error.errors) {
                const modalStateErrors = Object.keys(error.error.errors)
                  .filter((key) => error.error.errors[key])
                  .map((key) => error.error.errors[key])
                  .flat();

                throw modalStateErrors.flat();
              } else if (typeof error === 'object') {
                const translateService = this._injector.get(TranslateService);
                const msgs = error.error;

                if (typeof msgs === 'string' || msgs instanceof String) {
                  var message = msgs.toString();
                  var translated = translateService.instant(message);

                  const translateResult = getTranslatedBackendErrorMessage(message);
                  if (translateResult) {
                    if (translateResult.listOfVariables.length == 0) {

                      translated = translateService.instant(translateResult.messageForTranslate);

                    } else if (translateResult.listOfVariables.length == 1) {

                      var translatedMessageValue = translateService.instant(translateResult.messageForTranslate);
                      translated = formatString(translatedMessageValue, { 0: translateResult.listOfVariables[0] })

                    } else {

                      var translatedMessageValue = translateService.instant(translateResult.messageForTranslate);
                      translated = formatString(translatedMessageValue, { 0: translateResult.listOfVariables[0], 1: translateResult.listOfVariables[1] })
                    }
                  }
                  this._snackBar.open(translated, 'Close', {
                    panelClass: ['error-snackbar'],
                  });
                } else {
                  let errorMessage =
                    translateService.instant('There were several errors') +
                    ':\n';
                  for (const msg of msgs) {
                    var translated = msg ? translateService.instant(msg) : '';

                    const translateResult = getTranslatedBackendErrorMessage(msg);

                    if (translateResult) {
                      if (translateResult.listOfVariables.length == 0) {

                        translated = translateService.instant(translateResult.messageForTranslate);

                      } else if (translateResult.listOfVariables.length == 1) {

                        var translatedMessageValue = translateService.instant(translateResult.messageForTranslate);
                        translated = formatString(translatedMessageValue, { 0: translateResult.listOfVariables[0] })

                      } else {

                        var translatedMessageValue = translateService.instant(translateResult.messageForTranslate);
                        translated = formatString(translatedMessageValue, { 0: translateResult.listOfVariables[0], 1: translateResult.listOfVariables[1] })

                      }
                    }
                    errorMessage += (translated + '\n');
                  }
                  this._snackBar.open(`${errorMessage}`, 'Close', {
                    panelClass: ['error-snackbar'],
                  });
                }
              } else {
              }
              break;
            case 401:
              this.showSnackError(error, 'Please sign in.');
              this.router.navigate(['/']);
              // this.router.navigate(['access']);
              break;
            case 404:
              this.router.navigate(['error'], {
                queryParams: { message: 'Page not found' },
              });
              break;
            case 406:
              const translateService = this._injector.get(TranslateService);
              const msg = error.error
                ? translateService.instant(error.error)
                : '';

              this.router.navigate(['error'], {
                queryParams: { message: msg },
              });
              break;
            case 500:
              this.showSnackError(error, error.error?.message);
              break;
            case 403:
              break;

            default:
              this._snackBar.open('Something unexpected went wrong', 'Close');
              break;
          }
        }
        return throwError(error);
      })
    );
  }

  private showSnackError(error: any, extra?: string) {
    console.error(error);
    this._snackBar.open(
      `${error.statusText} ${error.status} - ${extra}`,
      'Close',
      {
        duration: 10000,
        panelClass: ['error-snackbar'],
      }
    );
  }
}
function getTranslatedBackendErrorMessage(message: string): ErrorMessageModel {
  if (message == null || message.length == 0) {
    return null;
  }
  var result: ErrorMessageModel = null;

  var messageCompare = message.match(/The student's location id of (\d+) does not match the users location id of (\d+)/);
  if (messageCompare) {
    result = new ErrorMessageModel();
    result.messageForTranslate = "ErrorLocationMismatch";
    result.listOfVariables.push(messageCompare[1]);
    result.listOfVariables.push(messageCompare[2]);
    return result;
  }
  var messageCompareCheck = message.startsWith("You may only edit your own notes");
  if (messageCompareCheck) {
    result = new ErrorMessageModel();
    result.messageForTranslate = "ErrorEditOwnNotes";
    return result;
  }
  messageCompare = message.match(/No student found with id (\d+)/);
  if (messageCompare) {
    result = new ErrorMessageModel();
    result.messageForTranslate = "ErrorNoStudentFound";
    result.listOfVariables.push(messageCompare[1]);
    return result;
  }
  messageCompareCheck = message.startsWith("The student's program location and your program location do not match.");
  if (messageCompareCheck) {
    result = new ErrorMessageModel();
    result.messageForTranslate = "ErrorProgramLocationMismatch";
    return result;
  }
  return null;
}

function formatString(template: string, values: { [key: string]: string }): string {
  return template.replace(/{(\d+)}/g, (match, key) => {
    return typeof values[key] !== "undefined" ? values[key] : match;
  });
}

export class ErrorMessageModel {
  messageForTranslate: string;
  listOfVariables: Array<string> = new Array<string>();
}

